import { render, staticRenderFns } from "./social-auth.vue?vue&type=template&id=71eae2a0&"
import script from "./social-auth.vue?vue&type=script&lang=js&"
export * from "./social-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71eae2a0')) {
      api.createRecord('71eae2a0', component.options)
    } else {
      api.reload('71eae2a0', component.options)
    }
    module.hot.accept("./social-auth.vue?vue&type=template&id=71eae2a0&", function () {
      api.rerender('71eae2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/social-auth.vue"
export default component.exports